import fetchAPI from '../fetchAPI';

export interface LookupItem {
  id: string;
  category: string;
  key: string;
  value?: string | null;
  label?: string | null;
  groupName?: string | null;
  sortOrder?: number | null;
  isActive?: boolean;
  metadata?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface LookupUpsertPayload {
  id?: string;
  category: string;
  key: string;
  value?: string | null;
  label?: string | null;
  groupName?: string | null;
  sortOrder?: number | null;
  isActive?: boolean | null;
  metadata?: string | null;
}

// Server responds with `{ code, data }` as the body, so the parsed body is
// nested under fetchAPI's own `.data`.
export const callGetLookups = async (
  category?: string
): Promise<iResponse<{ code: number; data: LookupItem[] }>> => {
  const queryString = category ? `category=${encodeURIComponent(category)}` : '';
  const response: iResponse<{ code: number; data: LookupItem[] }> = await fetchAPI({
    method: `GET`,
    route: `lookup`,
    queryString
  });
  return response;
};

export default callGetLookups;
